import React from "react";
import NewHeader from "./NewHeader";

export default function Layout(props) {
  const { children } = props;
  return <>
  <NewHeader/>
  {children}
  </>;
}
